export default __webpack_public_path__ + "static/media/ricardo.6ef4db1f.jpg";